module.exports = __webpack_public_path__ + "static/img/Tyreece-Tait.99e189f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyreece-Tait.jpg
// module id = eV4U
// module chunks = 0